import { keepPreviousData } from '@tanstack/react-query';
import {
    PortfolioCentralProductOverviewEntriesFilters,
    PortfolioCentralProductOverviewEntry,
    PortfolioGuidFilterType,
    useRepositoryQuery,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';
import { TableState } from '@optimus-web/core';

export const useGetCentralProductOverviewEntries = (
    tableState: TableState<PortfolioCentralProductOverviewEntry, PortfolioCentralProductOverviewEntriesFilters>,
    enterpriseId: string
) =>
    useRepositoryQuery(
        'portfolioCentralProducts',
        'getOverviewEntries',

        {
            ...tableState,
            enterpriseId,
        },
        {
            placeholderData: keepPreviousData,
        }
    );

export const useGetCentralProductDetail = (id?: PortfolioCentralProductOverviewEntry['id']) =>
    useRepositoryQuery(
        'portfolioCentralProducts',
        'getDetail',

        {
            id: id ?? '',
        },
        {
            placeholderData: keepPreviousData,
            enabled: !!id,
        }
    );

export const useGetPropertiesGroups = (propertyGroupIds: string[] | null) =>
    useRepositorySuspenseQuery('portfolioEnterpriseGroups', 'getAll', {
        pagination: { pageSize: 0, pageIndex: 0 },
        ...(propertyGroupIds && propertyGroupIds.length > 0
            ? {
                  filters: {
                      id: propertyGroupIds.map((propertyGroupId) => ({
                          value: propertyGroupId,
                          filterType: PortfolioGuidFilterType.Equals,
                      })),
                  },
              }
            : {}),
    });

export const useGetQuota = () => useRepositoryQuery('portfolioCentralProducts', 'getQuota', {});
